import styled from "styled-components";
import React from "react";
import { useTranslation } from 'react-i18next';
import "./style.css";

import { formatDateTz } from '../../utils/timezone';
import { formatPriceWithSymbol } from '../../utils/currency';
import { formatPhoneDisplay, toE164 } from '../../utils/phone';

import ModalConfirmacaoSenha from "../ModalConfirmacaoSenha"; // Importe o componente ModalConfirmacao

import ModalPdv from "../ModalPdv"
import {
  ImprimirPedido,
  cancelarPedido,
  getCurrentAccessToken,
  updateTipoPagamento,
} from "../../services/api";

import { saveToLocalStorage, getFromLocalStorage, removeFromLocalStorage } from "../../utils/localStorage"
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import io from 'socket.io-client';
import getApiUrl from '../../utils/getApiUrl';

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaMotorcycle, FaStore, FaCheckCircle } from "react-icons/fa";
import { BiComment } from "react-icons/bi";
import { MdQrCode2 } from "react-icons/md";

import { useNavigate } from "react-router-dom";

const DivPedidoContainer = styled.div`
  z-index: 15;
  position: fixed;
  top: 0;
  left: 0;
  display: ${({ showPedido }) => (showPedido ? "none" : "flex")};
  float: left;
  min-width: 100%;
  min-height: 100%;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;
  list-style: none;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  background-clip: padding-box;
  align-items: flex-start;
  justify-content: center;
  opacity: ${({ showPedido }) => (showPedido ? "0" : "1")};
  transition: opacity 0.3s ease-in-out;

  animation: fadeIn 0.3s ease-in-out;
  animation-fill-mode: forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @media (max-width: 980px){
    left: 0;
    padding: 10px;
  }
`;

const DivPedido = styled.div`
  z-index: 20;
  position: relative;
  margin-top: 20px;
  width: 60%;
  min-width: 600px;
  max-width: 900px;
  max-height: calc(100vh - 60px);
  list-style: none;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  background-clip: padding-box;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25),
              0 0 0 1px rgba(255, 255, 255, 0.1);
  animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  overflow-y: auto;

  @keyframes slideUp {
    0% {
      opacity: 0;
      transform: translateY(20px) scale(0.98);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  /* Notebooks com pouca altura */
  @media (max-height: 800px) {
    padding: 14px 18px;
    margin-top: 8px;
    max-height: calc(100vh - 30px);
    border-radius: 14px;
  }

  /* Responsividade para telas menores */
  @media (max-width: 980px) {
    width: 100%;
    min-width: 0;
    margin-top: 0;
    height: calc(100vh - 20px);
    max-height: calc(100vh - 20px);
    overflow: hidden;
    padding: 16px;
    border-radius: 16px;

    .closeModalPedido{
      top: 8px;
      right: 8px;
    }
  }
`;

const ModalPedido = ({
  setShowPedido,
  showPedido,
  setRefresh,
  infoPedido,
  setInfoPedido,

  handleAvancar,
  userID,
  showActions = true,
  hasCancelPassword,
  typePedido = 'delivery',
  isLoading = false, // Prop para indicar carregamento externo
  //tipoImpressao
}) => {
  //infoPedido && process.env.REACT_APP_ISDEVELOP === 'true' && console.log("infoPedido:",infoPedido)

  const { t } = useTranslation('orders');

  // Determina se os dados estão carregando (prop externa ou dados incompletos)
  const isDataLoading = isLoading || !infoPedido || !infoPedido._id || !infoPedido.itens;
  const navigate = useNavigate();
  const empresa = localStorage.getItem('empresa')
  const empresaParse = JSON.parse(empresa)

  const empresaObjId = empresaParse._id;
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingPayment, setEditingPayment] = useState(false);
  const [savingPayment, setSavingPayment] = useState(false);



  const [itensCarrinho, setItensCarrinho] = useState([]);
  const [nomeCliente, setNomeCliente] = useState("");
  const [telefone, setTelefone] = useState('');
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [savedFormaEntrega, setSavedFormaEntrega] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [cpfCnpjValue, setCpfCnpjValue] = useState('');
  const [valueDescricao, setValueDescricao] = useState('');

  // Estados para tracking de impressão em tempo real
  const [isPrinting, setIsPrinting] = useState(false);
  const printSocketRef = useRef(null);
  const printJobIdRef = useRef(null);
  const printTimeoutRef = useRef(null);

  // Calcular subtotal - usar mesma lógica do backend para consistência
  // subtotal = valor_total + desconto - taxa_entrega (valor_total ja tem desconto aplicado)
  const pedidoDesconto = infoPedido?.desconto || 0;
  const subTotal = (infoPedido?.valor_total || 0) + pedidoDesconto - (infoPedido?.entrega?.valor || 0);

  // Agrupa itens idênticos para exibição no modal (mesmo nome + preço + obs + adicionais)
  const itensAgrupados = useMemo(() => {
    if (!infoPedido?.itens) return [];
    const gerarChave = (item) => {
      const adicionaisStr = item.grupo_adicionais ? JSON.stringify(item.grupo_adicionais) : '';
      return `${item.nomeItem}_${item.valor}_${item.obs_item || ''}_${adicionaisStr}`;
    };
    const agrupados = new Map();
    infoPedido.itens.forEach(item => {
      const chave = gerarChave(item);
      if (agrupados.has(chave)) {
        agrupados.get(chave).quantidade += (item.quantidade || 1);
      } else {
        agrupados.set(chave, { ...item, quantidade: item.quantidade || 1 });
      }
    });
    return Array.from(agrupados.values());
  }, [infoPedido?.itens]);

  // Função para carregar os itens do infoPedido no localStorage
  // Agrupa itens idênticos (mesmo nome + mesmo preço + mesma obs + mesmos adicionais)
  const carregarItensNoCarrinhoParaEdicao = (itens) => {
    const carrinhoExistente = getFromLocalStorage('itensCarrinho') || [];

    // Gera uma chave de agrupamento para comparar itens
    const gerarChave = (item) => {
      const adicionaisStr = item.grupo_adicionais
        ? JSON.stringify(item.grupo_adicionais)
        : '';
      return `${item.nomeItem}_${item.valor}_${item.obs_item || ''}_${adicionaisStr}`;
    };

    // Agrupa itens idênticos somando as quantidades
    const agrupados = new Map();
    itens.forEach(item => {
      const chave = gerarChave(item);
      if (agrupados.has(chave)) {
        agrupados.get(chave).quantity += (item.quantidade || 1);
      } else {
        agrupados.set(chave, {
          title: item.nomeItem,
          obs_item: item.obs_item ?? "",
          quantity: item.quantidade || 1,
          price: item.valor,
          adicionais: item.grupo_adicionais
        });
      }
    });

    agrupados.forEach(itemParse => carrinhoExistente.push(itemParse));

    saveToLocalStorage('itensCarrinho', carrinhoExistente);
    setItensCarrinho(getFromLocalStorage('itensCarrinho'));
  };
  //
  const handleEditarPedido = () => {
    setShowModal(!showModal)
    if (infoPedido) {
      carregarItensNoCarrinhoParaEdicao(infoPedido.itens);
      setNomeCliente(infoPedido.nome_cliente);
      setTelefone(toE164(infoPedido.celular_cliente_completo || infoPedido.celular_cliente));
      setSelectedCliente({ nome: infoPedido.nome_cliente, telefone: infoPedido.celular_cliente, telefone_completo: infoPedido.celular_cliente_completo })

      //infoPedido && setFormaEntrega(infoPedido.entrega.tipo_entrega)
      setSavedFormaEntrega({
        formaEntrega: infoPedido.entrega?.tipo_entrega,
        valorEntrega: infoPedido.entrega?.valor,
        selectedAddress: infoPedido.entrega?.endereco
      });

      setSelectedPayment({
        paymentType: infoPedido.tipo_pagamento,
        valorTroco: infoPedido.valor_troco,
        valorPago: infoPedido.valor_total,
      });

      setCpfCnpjValue(infoPedido.cpf_cnpj);
      setValueDescricao(infoPedido.descricao ?? "")

    }

  }

  const handlePaymentChange = async (newPaymentType) => {
    if (!infoPedido?._id || savingPayment) return;
    setSavingPayment(true);
    try {
      const response = await updateTipoPagamento(infoPedido._id, newPaymentType, 0);
      if (response.data?.pedido) {
        setInfoPedido(response.data.pedido);
      } else {
        setInfoPedido(prev => ({ ...prev, tipo_pagamento: newPaymentType, valor_troco: 0 }));
      }
      setEditingPayment(false);
      toast(t('orderModal.payment.updated'), { autoClose: 2000, type: 'success' });
      if (setRefresh) setRefresh(true);
    } catch (error) {
      console.error('Erro ao atualizar pagamento:', error);
      toast(error?.response?.data?.msg || t('orderModal.payment.updateError', 'Erro ao atualizar pagamento'), { autoClose: 3000, type: 'error' });
    } finally {
      setSavingPayment(false);
    }
  };

  const closeModalPedido = () => {
    setShowPedido(!showPedido);
    // Limpa os dados do pedido para garantir loading na próxima abertura
    setInfoPedido(null);
    removeFromLocalStorage('itensCarrinho');
    setNomeCliente("");
    setTelefone('');
    setSelectedCliente({})
    setSavedFormaEntrega({});
    setSelectedPayment(null);
    setCpfCnpjValue('');
    setValueDescricao('');
    setItensCarrinho([]);
    // Limpa estado de impressão ao fechar modal
    setIsPrinting(false);
    if (printSocketRef.current) {
      printSocketRef.current.off('print_job_result');
      printSocketRef.current.disconnect();
      printSocketRef.current = null;
    }
    printJobIdRef.current = null;
    if (printTimeoutRef.current) {
      clearTimeout(printTimeoutRef.current);
      printTimeoutRef.current = null;
    }
  }

  useEffect(() => {
    (async () => {
      //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("infoPedido>",infoPedido)
      //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("dados>",response.data.vinculo.tempoBalcaoMin);
      //setTempoBalcaoMin(tempoBalcaoMinBD);
      //setTempoBalcaoMax(tempoBalcaoMaxBD);
      //setTempoEntregaMin(tempoEntregaMinBD);
      //setTempoEntregaMax(tempoEntregaMaxBD);
      //setSwitchState(tipoImpressao=='manual'?false:true);
    })();
    //eslint-disable-next-line
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true); // Abre o modal de confirmação
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Fecha o modal de confirmação
  };

  const handleCancelPedido = (senha) => {
    cancelarPedido(infoPedido._id, senha)
      .then((response) => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(response);
        if (response.status === 200) {
          toast(response.data.msg, { autoClose: 5000, type: "success" });
          setRefresh(true);
          closeModalPedido(); // Usa a função que limpa os dados
        } else {
          toast(response.data.msg, { autoClose: 5000, type: "error" });
        }
      })
      .catch((error) => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(error);
      }).finally(() => {
        setIsModalOpen(false);
      })
  };



  // Define origem do pedido (usa campo origem_pedido se disponível, senão fallback para createdBy)
  const isMongoObjectId = (value) => {
    if (!value) return false;
    const str = String(value);
    return /^[a-fA-F0-9]{24}$/.test(str);
  };

  const origemPedidoTexto = (() => {
    // ✅ NOVO: Usar campo origem_pedido se disponível
    const origemPedido = infoPedido?.origem_pedido;
    if (origemPedido) {
      const origemMap = {
        'whatsapp': t('orderModal.origin.whatsapp'),
        'cardapio': t('orderModal.origin.menu'),
        'pdv': t('orderModal.origin.pdv'),
        'mesa': t('orderModal.origin.table')
      };
      return origemMap[origemPedido] || `${t('card.orderNumber', { number: origemPedido })}`;
    }

    // Fallback para pedidos antigos (sem campo origem_pedido)
    const createdByRaw = infoPedido?.createdBy;
    if (!createdByRaw) return t('orderModal.origin.unknown');
    const createdBy = String(createdByRaw).toLowerCase();

    if (createdBy === 'whatsapp_bot') {
      return t('orderModal.origin.whatsapp');
    }
    if (createdBy.includes("cardapio") || createdBy.includes("cardápio")) {
      return t('orderModal.origin.menu');
    }
    if (isMongoObjectId(createdByRaw)) {
      return t('orderModal.origin.pdv');
    }
    return t('orderModal.origin.menu');
  })();





  /*if(_idUserEdit!=''){
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("IdToEdit",_idUserEdit)
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log('empresaCnpj',empresaVinculoCnpj)
        setselectData({value:'', label:'teste2'});
    }*/



  // Lógica para atualizar os dados do usuário no localStorage
  // Get the existing data
  // Código de criptografia removido - não está sendo utilizado na implementação atual

  /*const handleSubmit = () => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("TESTE SUBMIT:", tempoBalcaoMin)
    }*/



  // Socket.IO para feedback de impressão em tempo real
  const disconnectPrintSocket = useCallback(() => {
    if (printSocketRef.current) {
      printSocketRef.current.off('print_job_result');
      printSocketRef.current.disconnect();
      printSocketRef.current = null;
    }
    printJobIdRef.current = null;
    if (printTimeoutRef.current) {
      clearTimeout(printTimeoutRef.current);
      printTimeoutRef.current = null;
    }
  }, []);

  const connectPrintSocket = useCallback(() => {
    if (printSocketRef.current) return;

    const API_URL = getApiUrl();
    const objId = empresaObjId;
    if (!objId) return;

    const printSocket = io(API_URL, {
      withCredentials: true,
      transports: ['websocket'],
      auth: { token: getCurrentAccessToken() },
      reconnection: false,
    });

    printSocket.on('connect', () => {
      printSocket.emit('joinCompanyRoom', {
        companyId: objId,
        clientId: `print_modal_${Date.now()}`
      });
    });

    printSocket.on('print_job_result', (data) => {
      if (data.printJobId === printJobIdRef.current) {
        clearTimeout(printTimeoutRef.current);
        setIsPrinting(false);

        if (data.success) {
          toast.success(t('orderModal.print.success'), { autoClose: 3000 });
        } else {
          toast.error(
            `${t('orderModal.print.error')}: ${data.error || ''}`,
            { autoClose: 5000 }
          );
        }

        disconnectPrintSocket();
      }
    });

    printSocketRef.current = printSocket;
  }, [empresaObjId, disconnectPrintSocket, t]);

  // Cleanup Socket.IO ao desmontar ou fechar modal
  useEffect(() => {
    return () => {
      disconnectPrintSocket();
    };
  }, [disconnectPrintSocket]);

  const handlePrint = () => {
    if (isPrinting) return; // Evitar clique duplo
    setIsPrinting(true);

    // Conectar Socket.IO para escutar resultado
    connectPrintSocket();

    const isMesa = infoPedido.origem_pedido === 'mesa';

    const dadosPedido = {
      createdAt: infoPedido.createdAt,
      createdBy: isMesa ? (infoPedido.garcom_name || infoPedido.nome_cliente || 'Garçom') : infoPedido.createdBy,
      id_empresa: infoPedido.id_empresa,
      tipoPedido: isMesa ? 'Mesa' : (infoPedido.entrega?.tipo_entrega || 'Balcão'),
      numeroPedido: infoPedido.id_pedido_counter ?? infoPedido.id_pedido,
      itens: infoPedido.itens,
      cliente: {
        nome: infoPedido.nome_cliente,
        telefone: infoPedido.celular_cliente,
        telefone_completo: infoPedido.celular_cliente_completo || '',
        qtdPedidos: infoPedido.counter_qtd_pedido,
      },
      entrega: {
        endereco: isMesa ? '' : (
          (infoPedido?.entrega?.endereco?.rua || '') +
          ", " +
          (infoPedido?.entrega?.endereco?.numero || '') +
          ", " +
          (infoPedido?.entrega?.endereco?.complemento || '')
        ),
        referencia: infoPedido?.entrega?.endereco?.referencia,
        bairroAndCity: isMesa ? '' : (
          (infoPedido?.entrega?.endereco?.bairro || '') +
          ", " +
          (infoPedido?.entrega?.endereco?.cidade || '')
        ),
        cep: infoPedido?.entrega?.endereco?.cep,
      },
      mesa_name: isMesa ? (infoPedido.mesa_name || 'Mesa') : undefined,
      pagamento: {
        forma: infoPedido.tipo_pagamento,
        subtotal: infoPedido.valor_total + (infoPedido.desconto || 0) - (infoPedido.entrega?.valor || 0),
        taxaEntrega: infoPedido.entrega?.valor || 0,
        desconto: infoPedido.desconto || 0,
        total: infoPedido.valor_total,
        payment_confirmed: infoPedido.payment_confirmed || false,
      },
      observacoes: [infoPedido.descricao, infoPedido.obs].filter(Boolean).join(' | ') || '',
      troco: infoPedido.valor_troco,
    };

    ImprimirPedido(dadosPedido)
      .then((response) => {
        const printJobId = response.data?.printJobId;
        if (printJobId) {
          printJobIdRef.current = printJobId;
          // Timeout de 30s caso Electron não responda
          printTimeoutRef.current = setTimeout(() => {
            setIsPrinting(false);
            disconnectPrintSocket();
            toast.warn(t('orderModal.print.timeout'), { autoClose: 5000 });
          }, 30000);
        } else {
          // Fallback se backend não retornar printJobId
          setIsPrinting(false);
          disconnectPrintSocket();
          toast.success(response.data?.msg || t('orderModal.print.sent'), { autoClose: 3000 });
        }
      })
      .catch((error) => {
        setIsPrinting(false);
        disconnectPrintSocket();
        toast.error(error.response?.data?.msg || t('orderModal.print.error'), { autoClose: 5000 });
      });
  };

  // Função para direcionar ao WhatsApp
  const direcionarParaWhatsApp = () => {
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🎯 [DEBUG MODAL] Direcionando para WhatsApp:', {
      infoPedido_presente: !!infoPedido,
      nome_cliente: infoPedido?.nome_cliente,
      celular_cliente: infoPedido?.celular_cliente,
      lead_id: infoPedido?.lead_id
    });

    if (infoPedido?.nome_cliente && infoPedido?.celular_cliente) {
      const dadosParaEnviar = {
        lead_id: infoPedido.lead_id,
        nome: infoPedido.nome_cliente,
        celular: infoPedido.celular_cliente.split('@')[0], // Remove domínio @s.whatsapp.net se existir
      };
      
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('✅ [DEBUG MODAL] Dados enviados para WhatsApp:', dadosParaEnviar);
      
      navigate("/whatsapp", { 
        state: dadosParaEnviar
      });
    } else {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.log('❌ [DEBUG MODAL] Dados insuficientes para abrir WhatsApp');
      toast.error(t('common:cancelOrder.insufficientData'), {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  // Handler para fechar ao clicar fora do modal
  const handleOverlayClick = (e) => {
    // Só fecha se clicar diretamente no overlay (não em elementos filhos)
    if (e.target === e.currentTarget) {
      closeModalPedido();
    }
  };

  return (
    <DivPedidoContainer showPedido={!!showPedido} onClick={handleOverlayClick}>
      <ModalPdv setShowModal={setShowModal}
        typePedido={typePedido}
        showModal={showModal}
        infoPedido={infoPedido}
        setInfoPedido={setInfoPedido}
        itensCarrinho={itensCarrinho}
        setItensCarrinho={setItensCarrinho}
        nomeCliente={nomeCliente}
        setNomeCliente={setNomeCliente}
        telefone={telefone}
        setTelefone={setTelefone}
        selectedCliente={selectedCliente}
        setSelectedCliente={setSelectedCliente}
        savedFormaEntrega={savedFormaEntrega}
        setSavedFormaEntrega={setSavedFormaEntrega}
        selectedPayment={selectedPayment}
        setSelectedPayment={setSelectedPayment}
        cpfCnpjValue={cpfCnpjValue}
        setCpfCnpjValue={setCpfCnpjValue}
        valueDescricao={valueDescricao}
        setValueDescricao={setValueDescricao}
        setRefresh={setRefresh}
      />
      <DivPedido>
        {/* Botão fechar - sempre visível */}
        <div className="closeModalPedido" onClick={() => closeModalPedido()}>
          <div
            iconname="x"
            iconcolor="#2B2B2B"
            iconsize={18}
            className="iconCancel"
            style={{ height: 18, display: "flex" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={18}
              height={18}
              viewBox="0 0 24 24"
              fill="none"
              stroke="#2B2B2B"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-x"
            >
              <line x1={18} y1={6} x2={6} y2={18} />
              <line x1={6} y1={6} x2={18} y2={18} />
            </svg>
          </div>
        </div>

        {/* Loading State */}
        {isDataLoading ? (
          <div className="modal-pedido-loading">
            <div className="modal-pedido-loading-spinner"></div>
            <span>{t('common:messages.loading')}</span>
          </div>
        ) : (
          <>
        <ModalConfirmacaoSenha
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onConfirm={handleCancelPedido} // Passa a função handleCancelPedido como callback
          hasCancelPassword={hasCancelPassword}
        />

        <div className="box-content-pedido">
          <div className="header-pedido">
            <div className="container-header-pedido">
              <div className={"icon-box"}>
                <pedeja-icon iconcolor="#5A5A5A" iconsize="28px">
                  <svg
                    width="28px"
                    height="28px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    {" "}
                    <path
                      d="M22.0625 8.98125V8.9625C22.0625 8.94375 22.0625 8.93437 22.0531 8.925V8.89688C22.0531 8.8875 22.0438 8.86875 22.0438 8.85938L20.6938 4.14375C20.6165 3.86964 20.4521 3.62812 20.2255 3.45562C19.9989 3.28312 19.7223 3.18902 19.4375 3.1875H5.56251C5.27771 3.18902 5.00114 3.28312 4.77453 3.45562C4.54791 3.62812 4.38355 3.86964 4.30626 4.14375L2.95626 8.85C2.95626 8.85938 2.94688 8.87813 2.94688 8.8875V8.91562C2.93751 8.925 2.93751 8.93437 2.93751 8.95312V10.5C2.93649 11.0691 3.07221 11.6302 3.33324 12.136C3.59428 12.6417 3.97299 13.0774 4.43751 13.4062V19.5C4.43751 19.8481 4.57579 20.1819 4.82193 20.4281C5.06807 20.6742 5.40191 20.8125 5.75001 20.8125H19.25C19.5981 20.8125 19.9319 20.6742 20.1781 20.4281C20.4242 20.1819 20.5625 19.8481 20.5625 19.5V13.4062C21.027 13.0774 21.4057 12.6417 21.6668 12.136C21.9278 11.6302 22.0635 11.0691 22.0625 10.5V8.98125ZM5.38438 4.45312C5.39462 4.41344 5.41758 4.3782 5.44975 4.3528C5.48192 4.32741 5.52153 4.31325 5.56251 4.3125H19.4375C19.4785 4.31325 19.5181 4.32741 19.5503 4.3528C19.5824 4.3782 19.6054 4.41344 19.6156 4.45312L20.75 8.4375H4.25001L5.38438 4.45312ZM10.0625 9.5625H14.9375V10.5C14.9375 11.1465 14.6807 11.7665 14.2236 12.2236C13.7665 12.6807 13.1465 12.9375 12.5 12.9375C11.8535 12.9375 11.2336 12.6807 10.7764 12.2236C10.3193 11.7665 10.0625 11.1465 10.0625 10.5V9.5625ZM4.06251 9.5625H8.93751V10.5C8.93504 11.1457 8.67744 11.7643 8.22085 12.2208C7.76426 12.6774 7.14571 12.935 6.50001 12.9375C6.10172 12.9368 5.70945 12.8403 5.35626 12.6562C5.31214 12.6164 5.26137 12.5847 5.20626 12.5625C4.85668 12.3436 4.56837 12.0395 4.36833 11.6788C4.16829 11.3181 4.06307 10.9125 4.06251 10.5V9.5625ZM19.4375 19.5C19.4375 19.5497 19.4178 19.5974 19.3826 19.6326C19.3474 19.6677 19.2997 19.6875 19.25 19.6875H5.75001C5.70028 19.6875 5.65259 19.6677 5.61742 19.6326C5.58226 19.5974 5.56251 19.5497 5.56251 19.5V13.9406C5.86878 14.0198 6.18367 14.0607 6.50001 14.0625C7.09736 14.0617 7.68497 13.9111 8.20908 13.6245C8.73318 13.3379 9.17703 12.9244 9.50001 12.4219C9.82228 12.9251 10.266 13.3392 10.7902 13.626C11.3145 13.9128 11.9024 14.0631 12.5 14.0631C13.0976 14.0631 13.6855 13.9128 14.2098 13.626C14.734 13.3392 15.1777 12.9251 15.5 12.4219C15.823 12.9244 16.2668 13.3379 16.7909 13.6245C17.315 13.9111 17.9027 14.0617 18.5 14.0625C18.8163 14.0607 19.1312 14.0198 19.4375 13.9406V19.5ZM19.7938 12.5625C19.7386 12.5847 19.6879 12.6164 19.6438 12.6562C19.2906 12.8403 18.8983 12.9368 18.5 12.9375C17.8543 12.935 17.2357 12.6774 16.7792 12.2208C16.3226 11.7643 16.065 11.1457 16.0625 10.5V9.5625H20.9375V10.5C20.9369 10.9125 20.8317 11.3181 20.6317 11.6788C20.4316 12.0395 20.1433 12.3436 19.7938 12.5625Z"
                      fill="#5A5A5A"
                      stroke="#5A5A5A"
                      strokeWidth="0.8"
                    />
                  </svg>
                </pedeja-icon>
              </div>
              <div className="title">
                <span>{t('orderModal.orderNumber', { number: infoPedido.id_pedido_counter ?? infoPedido.id_pedido })}</span>
              </div>
              <div
                className={
                  infoPedido.status_pedido==="1"
                    ? "status-order analise"
                    : infoPedido.status_pedido==="2"
                      ? "status-order producao"
                      : infoPedido.status_pedido==="3"
                        ? "status-order pronto"
                        : "status-order finalizado"
                }
              >
                {infoPedido.status_pedido==="1"
                  ? t('orderModal.statusAnalysis')
                  : infoPedido.status_pedido==="2"
                    ? t('orderModal.statusProduction')
                    : infoPedido.status_pedido==="3"
                      ? t('orderModal.statusReady')
                      : t('orderModal.statusCompleted')}
              </div>
            </div>

            <div className="container-header-pedido buttonsTitle">
              <div className="time-OnModalPedido">
                <div iconname="clock" iconcolor="#0067AC" iconsize="12px">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12px"
                    height="12px"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#0067AC"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-clock"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </div>
                <span>
                  {formatDateTz(infoPedido.createdAt)}
                </span>
              </div>
              {showActions && (
                <>
                  {infoPedido.status_pedido !== "4" &&
                    <div
                      className={"icon-btn trash"}
                      onClick={handleOpenModal}
                      data-tooltip={t('orderModal.tooltips.cancel')}
                    >
                      <div iconname="trash-2" style={{ height: 24 }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-trash-2"
                        >
                          <polyline points="3 6 5 6 21 6" />
                          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                          <line x1={10} y1={11} x2={10} y2={17}></line>
                          <line x1={14} y1={11} x2={14} y2={17}></line>
                        </svg>
                      </div>
                    </div>
                  }
                  {infoPedido.status_pedido !== "4" &&
                    <div className={"icon-btn edit-print"}
                      onClick={() => handleEditarPedido()}
                      data-tooltip={t('orderModal.tooltips.edit')}
                    >
                      <div style={{ height: 24 }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-edit-2"
                        >
                          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                        </svg>
                      </div>
                    </div>
                  }
                  <div
                    className={`icon-btn edit-print ${isPrinting ? 'printing' : ''}`}
                    onClick={() => !isPrinting && handlePrint()}
                    data-tooltip={isPrinting ? t('orderModal.print.printing') : t('orderModal.tooltips.print')}
                    style={{ opacity: isPrinting ? 0.7 : 1, cursor: isPrinting ? 'not-allowed' : 'pointer' }}
                  >
                    <div style={{ height: 24 }}>
                      {isPrinting ? (
                        <svg width={24} height={24} viewBox="0 0 24 24" className="print-spinner">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" fill="none" strokeDasharray="31.4 31.4" strokeLinecap="round" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-printer"
                        >
                          <polyline points="6 9 6 2 18 2 18 9" />
                          <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                          <rect x={6} y={14} width={12} height={8} />
                        </svg>
                      )}
                    </div>
                  </div>
                  {infoPedido.status_pedido !== "4" &&
                    <div
                      className={"icon-btn avancar"}
                      onClick={(event) => {
                        handleAvancar(
                          event,
                          infoPedido._id,
                          infoPedido.id_pedido,
                          infoPedido.status_pedido
                        );
                        closeModalPedido();
                      }}
                      data-tooltip={t('orderModal.tooltips.advance')}
                    >
                      <div style={{ height: 24 }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-arrow-right"
                        >
                          <line x1={5} y1={12} x2={19} y2={12} />
                          <polyline points="12 5 19 12 12 19" />
                        </svg>
                      </div>
                    </div>
                  }
                </>
              )}
            </div>
          </div>
          <div className="bodyModalPedido">
            <div className="bodyLeft">
              <div className="info-box">
                <div className="container-header-pedido">
                  <div className="icon-box">
                    <pedeja-icon iconcolor="#5A5A5A" iconsize="28px">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22px"
                        height="22px"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#5A5A5A"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-user"
                      >
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx={12} cy={7} r={4} />
                      </svg>
                    </pedeja-icon>
                  </div>
                  <div className="coluna-cliente">
                    <div className="cliente">{t('orderModal.client')}</div>
                    <div className="cliente-nome">
                      {infoPedido.nome_cliente}
                    </div>
                    <div className="cliente-telefone">
                      {formatPhoneDisplay(infoPedido.celular_cliente_completo || infoPedido.celular_cliente)}
                    </div>
                    <div className="cliente-numPedidos">
                      {t('orderModal.orderCount')}
                      {infoPedido.counter_qtd_pedido > 1 ? (
                        <div className="label-recorrencia-pedidoMoreThanOne">
                          <div className="caixaNumero" style={{ height: 15 }}>
                            <span style={{ fontSize: 10 }}>
                              {infoPedido.counter_qtd_pedido}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="label-recorrencia-pedido">
                          <div className="caixaNumero" style={{ height: 15 }}>
                            <span style={{ fontSize: 10 }}>{t('orderModal.firstOrder')}</span>
                          </div>
                        </div>
                      )}
                      {t('orderModal.orderCountSuffix')}
                    </div>
                  </div>
                </div>

                <div className="icon-box sendToWhatsApp" onClick={direcionarParaWhatsApp}>
                  <pedeja-icon iconcolor="#5A5A5A" iconsize="28px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22px"
                      height="22px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-external-link"
                    >
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1={10} y1={14} x2={21} y2={3} />
                    </svg>
                  </pedeja-icon>
                </div>
              </div>

              <div className="info-box">
                <div className="container-header-pedido">
                  <div className="icon-box" style={infoPedido.payment_confirmed ? { background: 'linear-gradient(135deg, rgba(40, 167, 69, 0.15), rgba(52, 199, 89, 0.1))', border: '1px solid rgba(40, 167, 69, 0.2)' } : {}}>
                    <pedeja-icon iconcolor={infoPedido.payment_confirmed ? "#28a745" : "#5A5A5A"} iconsize="28px">
                      {infoPedido.tipo_pagamento==="Dinheiro" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22px"
                          height="22px"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#5A5A5A"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-dollar-sign"
                        >
                          <line x1={12} y1={1} x2={12} y2={23} />
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                        </svg>
                      ) : (infoPedido.tipo_pagamento==="Pix" || infoPedido.tipo_pagamento==="PixOnline" || infoPedido.tuna_payment_method==="pix") ? (
                        <MdQrCode2 size={22} color={infoPedido.payment_confirmed ? "#28a745" : "#5A5A5A"} />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22px"
                          height="22px"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke={infoPedido.payment_confirmed ? "#28a745" : "#5A5A5A"}
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-credit-card"
                        >
                          <rect
                            x={1}
                            y={4}
                            width={22}
                            height={16}
                            rx={2}
                            ry={2}
                          />
                          <line x1={1} y1={10} x2={23} y2={10} />
                        </svg>
                      )}
                    </pedeja-icon>
                  </div>
                  <div className="coluna-cliente" style={{ flex: 1 }}>
                    {editingPayment && infoPedido.status_pedido !== "4" && !infoPedido.payment_confirmed ? (
                      /* Seletor inline de forma de pagamento */
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                          {[
                            { key: 'Dinheiro', label: t('payment.money'), icon: '$' },
                            { key: 'Cartão', label: t('payment.card'), icon: '💳' },
                            { key: 'Pix', label: t('payment.pix'), icon: '' },
                          ].map(opt => (
                            <button
                              key={opt.key}
                              disabled={savingPayment}
                              onClick={() => handlePaymentChange(opt.key)}
                              style={{
                                padding: '6px 14px',
                                borderRadius: '20px',
                                border: infoPedido.tipo_pagamento === opt.key ? '2px solid rgb(49, 140, 213)' : '1px solid #d1d5db',
                                background: infoPedido.tipo_pagamento === opt.key ? 'rgba(49, 140, 213, 0.1)' : 'white',
                                color: infoPedido.tipo_pagamento === opt.key ? 'rgb(49, 140, 213)' : '#4a5568',
                                fontWeight: infoPedido.tipo_pagamento === opt.key ? '600' : '400',
                                fontSize: '13px',
                                cursor: savingPayment ? 'wait' : 'pointer',
                                transition: 'all 0.15s ease',
                              }}
                            >
                              {opt.label}
                            </button>
                          ))}
                          <button
                            onClick={() => setEditingPayment(false)}
                            style={{
                              padding: '6px 10px',
                              borderRadius: '20px',
                              border: '1px solid #e5e7eb',
                              background: '#f9fafb',
                              color: '#9ca3af',
                              fontSize: '12px',
                              cursor: 'pointer',
                            }}
                          >
                            ✕
                          </button>
                        </div>
                      </div>
                    ) : (
                      /* Exibição normal do pagamento */
                      <>
                        <div className="cliente" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          {infoPedido.tipo_pagamento === "PixOnline" ? t('orderModal.payment.pixOnline')
                            : infoPedido.tipo_pagamento === "CartaoOnline" ? t('orderModal.payment.cardOnline')
                            : infoPedido.tipo_pagamento === "Dinheiro" ? t('payment.money')
                            : infoPedido.tipo_pagamento === "Pix" ? t('payment.pix')
                            : infoPedido.tipo_pagamento === "Crédito" || infoPedido.tipo_pagamento === "Credito" ? t('payment.credit')
                            : infoPedido.tipo_pagamento === "Débito" || infoPedido.tipo_pagamento === "Debito" ? t('payment.debit')
                            : infoPedido.tipo_pagamento === "ValeRefeição" || infoPedido.tipo_pagamento === "ValeRefeicao" ? t('payment.voucher')
                            : infoPedido.tipo_pagamento}

                          {infoPedido.payment_confirmed && (
                            <span style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '4px',
                              background: 'linear-gradient(135deg, #28a745, #34c759)',
                              color: 'white',
                              fontSize: '10px',
                              fontWeight: '700',
                              padding: '4px 10px',
                              borderRadius: '20px',
                              letterSpacing: '0.5px',
                              boxShadow: '0 2px 6px rgba(40, 167, 69, 0.3)',
                            }}>
                              <FaCheckCircle size={10} />
                              {t('orderModal.payment.paid')}
                            </span>
                          )}

                          {/* Botão editar pagamento - só aparece se pedido não finalizado e não pago online */}
                          {infoPedido.status_pedido !== "4" && !infoPedido.payment_confirmed && (
                            <button
                              onClick={() => setEditingPayment(true)}
                              style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                color: '#9ca3af',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                              title={t('orderModal.payment.editTooltip') || 'Alterar forma de pagamento'}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" /></svg>
                            </button>
                          )}
                        </div>
                        {infoPedido?.tipo_pagamento === "Dinheiro" ? (
                          <div className="cliente-nome">
                            {infoPedido?.valor_troco === 0
                              ? t('orderModal.payment.changeNotNeeded')
                              : `${t('orderModal.payment.changeFor')} ${formatPriceWithSymbol(infoPedido?.valor_troco)}`}
                          </div>
                        ) : null}
                        {infoPedido.payment_confirmed && infoPedido.payment_confirmed_at && (
                          <div className="cliente-nome" style={{ color: '#28a745', fontSize: '12px' }}>
                            {t('orderModal.payment.paidAt')} {formatDateTz(infoPedido.payment_confirmed_at)}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="info-box">
                <div className="container-header-pedido">
                  <div className="icon-box">
                    {infoPedido?.origem_pedido === 'mesa' ? (
                      <FaStore fontSize={22} />
                    ) : infoPedido?.entrega?.tipo_entrega === "Retirada" ? (
                      <FaStore fontSize={22} />
                    ) : (
                      <FaMotorcycle fontSize={22} />
                    )}
                  </div>
                  <div className="coluna-cliente">
                    <div className="cliente">
                      {infoPedido?.origem_pedido === 'mesa'
                        ? (infoPedido?.mesa_name || t('orderModal.tableLabel', 'Mesa'))
                        : infoPedido?.entrega?.tipo_entrega === "Entrega"
                          ? t('orderModal.delivery.title')
                          : infoPedido?.entrega?.tipo_entrega === "Retirada"
                            ? t('orderModal.delivery.pickup')
                            : infoPedido?.entrega?.tipo_entrega}
                    </div>
                    <div className="cliente-nome">
                      {infoPedido?.origem_pedido === 'mesa'
                        ? t('orderModal.delivery.pickupAtStore')
                        : infoPedido?.entrega?.tipo_entrega === "Entrega"
                          ? `${infoPedido?.entrega?.endereco?.rua}, ${infoPedido?.entrega?.endereco?.numero
                          }, ${infoPedido?.entrega?.endereco?.bairro}, ${infoPedido?.entrega?.endereco?.cidade
                          } | ${t('orderModal.delivery.complement')} ${infoPedido?.entrega?.endereco?.complemento
                          }${infoPedido?.entrega?.endereco?.referencia
                            ? ` | ${t('orderModal.delivery.reference')} ${infoPedido?.entrega?.endereco?.referencia}`
                            : ""
                          }`
                          : t('orderModal.delivery.pickupAtStore')}
                    </div>
                  </div>
                </div>
              </div>

              {/* Observação do pedido (descricao - PDV) */}
              {infoPedido.descricao && infoPedido.descricao.trim() !== "" ? (
                <div className="info-box">
                  <div className="container-header-pedido">
                    <div className="icon-box">
                      <BiComment fontSize={22} />
                    </div>
                    <div className="coluna-cliente">
                      <div className="cliente">{t('orderModal.observation')}</div>
                      <div className="cliente-nome">{infoPedido.descricao}</div>
                    </div>
                  </div>
                </div>
              ) : null}

              {/* Observação adicional (obs - WhatsApp Bot) */}
              {infoPedido.obs && infoPedido.obs.trim() !== "" ? (
                <div className="info-box">
                  <div className="container-header-pedido">
                    <div className="icon-box">
                      <BiComment fontSize={22} />
                    </div>
                    <div className="coluna-cliente">
                      <div className="cliente">{t('orderModal.customerObservation')}</div>
                      <div className="cliente-nome">{infoPedido.obs}</div>
                    </div>
                  </div>
                </div>
              ) : null}

              <div className="info-box">
                <div className="container-header-pedido">
                  <div className="icon-box">
                    <pedeja-icon iconcolor="#5A5A5A" iconsize="28px">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22px"
                        height="22px"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#5A5A5A"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-share-2"
                      >
                        <circle cx={18} cy={5} r={3} />
                        <circle cx={6} cy={12} r={3} />
                        <circle cx={18} cy={19} r={3} />
                        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                      </svg>
                    </pedeja-icon>
                  </div>
                  <div className="coluna-cliente">
                    <div className="cliente">{t('orderModal.origin.title')}</div>
                    <div className="cliente-nome">{origemPedidoTexto}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bodyRight">
              <div className="container-resumo-pedido">
                <div className="pedido-info-title">{t('orderModal.items.title')}</div>
                <div className="itens-pedido-body">
                  <div className="arrayPedidos">
                    <div className="info-pedidos">
                      {itensAgrupados.length > 0 &&
                        itensAgrupados.map((dados, i) => (
                          <div key={`${dados.nomeItem}-${i}`}>
                            <div className="info-pedidos-title">
                              <div className="info-pedidos-title">
                                {parseInt(dados.quantidade)}x {dados.nomeItem}
                              </div>
                              <span className="preco-item">
                                {formatPriceWithSymbol(dados.valor * dados.quantidade)}
                              </span>
                            </div>
                            {dados.grupo_adicionais &&
                              dados.grupo_adicionais.map(
                                (grupo_adicionais, idx) => (
                                  <div
                                    key={`${dados.nomeItem}-${grupo_adicionais.grupoTitle}-${idx}`}
                                    className="box-adicionais-modal-item"
                                  >
                                    <span>{grupo_adicionais.grupoTitle}</span>
                                    {grupo_adicionais && Array.isArray(grupo_adicionais.adicionais) &&
                                      grupo_adicionais.adicionais.map((adicional, adIdx) => (
                                        <div
                                          key={`${dados.nomeItem}-${grupo_adicionais.grupoTitle}-${adicional.title}-${adIdx}`}
                                          className="info-adicionais-title"
                                        >
                                          <div className="info-adicionais-title">
                                            {grupo_adicionais.calcular_maior_valor || grupo_adicionais.calcular_media
                                              ? adicional.quantity > grupo_adicionais.adicionais.length
                                                ? `${grupo_adicionais.adicionais.length}/${grupo_adicionais.adicionais.length}`
                                                : `${adicional.quantity}/${grupo_adicionais.adicionais.length}`
                                              : `${parseInt(adicional.quantity)}x`}{" "}
                                            {adicional.title}
                                          </div>
                                          <span className="preco-item">
                                            {
                                              grupo_adicionais.calcular_media
                                                ? formatPriceWithSymbol(
                                                  (
                                                    Array.isArray(grupo_adicionais.adicionais)
                                                      ? grupo_adicionais.adicionais.reduce(
                                                        (acc, subAdicional) => acc + (subAdicional.price * subAdicional.quantity),
                                                        0
                                                      )
                                                      : 0
                                                  ) /
                                                  (
                                                    Array.isArray(grupo_adicionais.adicionais)
                                                      ? grupo_adicionais.adicionais.reduce(
                                                        (acc, subAdicional) => acc + subAdicional.quantity,
                                                        0
                                                      )
                                                      : 1
                                                  ) /
                                                  (grupo_adicionais.adicionais?.length || 1)
                                                )
                                                : grupo_adicionais.calcular_maior_valor
                                                  ? (
                                                    adicional.price === Math.max(
                                                      ...(Array.isArray(grupo_adicionais.adicionais)
                                                        ? grupo_adicionais.adicionais.map(subAdicional => subAdicional.price)
                                                        : [0])
                                                    )
                                                      ? formatPriceWithSymbol(Math.max(
                                                        ...(Array.isArray(grupo_adicionais.adicionais)
                                                          ? grupo_adicionais.adicionais.map(subAdicional => subAdicional.price)
                                                          : [0])
                                                      ))
                                                      : formatPriceWithSymbol(0)
                                                  )
                                                  : formatPriceWithSymbol(adicional.price * adicional.quantity)
                                            }
                                          </span>
                                        </div>
                                      ))
                                    }

                                  </div>
                                )
                              )}

                            {dados.obs_item && dados.obs_item !== "" ? (
                              <span className="preco-item obsItemModalPedido">
                                {t('orderModal.itemObservation')} {dados.obs_item}
                              </span>
                            ) : null}
                          </div>
                        ))}

                      <div className="subTotal">
                        {t('orderModal.items.subtotal')}
                        <span>
                          {formatPriceWithSymbol(subTotal || 0)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rodape-total">
                <div className="rodape-row">
                  <div className="texto">{t('orderModal.summary.subtotal')}</div>
                  <div className="texto">
                    {formatPriceWithSymbol(subTotal || 0)}
                  </div>
                </div>
                {infoPedido.entrega?.tipo_entrega === "Entrega" ? (
                  <div className="rodape-row">
                    <div className="texto">{t('orderModal.summary.deliveryFee')}</div>
                    <div className="texto">
                      {formatPriceWithSymbol(infoPedido.entrega?.valor || 0)}
                    </div>
                  </div>
                ) : null}

                {pedidoDesconto > 0 && (
                  <div className="rodape-row">
                    <div className="texto" style={{ color: '#ef4444' }}>{t('orderModal.summary.discount')}</div>
                    <div className="texto" style={{ color: '#ef4444', fontWeight: '600' }}>
                      -{formatPriceWithSymbol(pedidoDesconto)}
                    </div>
                  </div>
                )}

                <div className="rodape-row">
                  <div className="texto bold">{t('orderModal.summary.total')}</div>
                  <div className="texto bold">
                    {formatPriceWithSymbol(infoPedido?.valor_total || 0)}
                  </div>
                </div>

                {/* Seção de valor a receber - zerado quando pagamento online confirmado */}
                <div className="rodape-row" style={{
                  marginTop: '12px',
                  paddingTop: '12px',
                  borderTop: '2px solid #e8ecef',
                  background: infoPedido.payment_confirmed ? 'rgba(40, 167, 69, 0.08)' : 'transparent',
                  margin: '12px -16px -16px -16px',
                  padding: '14px 16px',
                  borderRadius: '0 0 12px 12px'
                }}>
                  <div className="texto bold" style={{
                    color: infoPedido.payment_confirmed ? '#28a745' : '#2b3a4a',
                    fontSize: '14px'
                  }}>
                    {infoPedido.payment_confirmed ? t('orderModal.summary.paidOnline') : t('orderModal.summary.toReceive')}
                  </div>
                  <div className="texto bold" style={{
                    color: infoPedido.payment_confirmed ? '#28a745' : '#2b3a4a',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '16px',
                    fontWeight: '700'
                  }}>
                    {infoPedido.payment_confirmed ? (
                      <>
                        <FaCheckCircle size={16} color="#28a745" />
                        <span>{formatPriceWithSymbol(0)}</span>
                      </>
                    ) : (
                      <>
                        {formatPriceWithSymbol(infoPedido?.valor_total || 0)}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          </>
        )}
      </DivPedido>
    </DivPedidoContainer>
  );
};

export default ModalPedido;
